// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MwoG","col":"styles_col__2AxHa","actions":"styles_actions__SH0hY","conflict":"styles_conflict__zCPU3"};